export const CONSTANTS = {
	API_URL: "/api",
} as const;
